.gemOutline {
  polygon,
  path {
    fill: none;
    stroke: #878787;
    stroke-width: 0.4;
    stroke-opacity: 1;
    stroke-linecap: round;
    stroke-miterlimit: 1;
  }
  *[class^='cls-'] {
    opacity: 2 !important;
  }
}

.gemOutlineBrown {
  polygon,
  path {
    fill: none;
    stroke: var(--color-secondary);
    stroke-width: 0.4;
    stroke-opacity: 1;
    stroke-linecap: round;
    stroke-miterlimit: 1;
  }
  *[class^='cls-'] {
    opacity: 2 !important;
  }
}

.gemOutlineGreen {
  polygon,
  path {
    fill: none;
    stroke: var(--color-accent);
    stroke-width: 0.4;
    stroke-opacity: 1;
    stroke-linecap: round;
    stroke-miterlimit: 1;
  }
  *[class^='cls-'] {
    opacity: 2 !important;
  }
}

.gemOutlineWhite {
  polygon,
  path {
    fill: none;
    stroke: var(--color-white);
    stroke-width: 0.4;
    stroke-opacity: 1;
    stroke-linecap: round;
    stroke-miterlimit: 1;
  }
  *[class^='cls-'] {
    opacity: 2 !important;
  }
}

.gem {
  height: 100%;

  :global(.cls-1) {
    opacity: 0.1;
  }
  :global(.cls-2) {
    opacity: 0.2;
  }
  :global(.cls-3) {
    opacity: 0.3;
  }
  :global(.cls-4) {
    opacity: 0.4;
  }
  :global(.cls-5) {
    opacity: 0.5;
  }
  :global(.cls-6) {
    opacity: 0.6;
  }
  :global(.cls-7) {
    opacity: 0.7;
  }
  :global(.cls-8) {
    opacity: 0.8;
  }
  :global(.cls-9) {
    opacity: 0.9;
  }
  :global(.cls-10) {
    opacity: 1;
  }
}

.gemBold {
  polygon,
  path {
    stroke-width: 1;
  }

  :global(.cls-1) {
    opacity: 0.55;
  }
  :global(.cls-2) {
    opacity: 0.6;
  }
  :global(.cls-3) {
    opacity: 0.65;
  }
  :global(.cls-4) {
    opacity: 0.7;
  }
  :global(.cls-5) {
    opacity: 0.75;
  }
  :global(.cls-6) {
    opacity: 0.8;
  }
  :global(.cls-7) {
    opacity: 0.85;
  }
  :global(.cls-8) {
    opacity: 0.9;
  }
  :global(.cls-9) {
    opacity: 0.95;
  }
  :global(.cls-10) {
    opacity: 1;
  }
}
